import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';

type Props = {
  open: boolean;
  onClose: () => void;
  /** 功能名称，如「内容与样式」 */
  feature: string;
};

export function PcOnlyHintModal({ open, onClose, feature }: Props) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="请在电脑端操作"
      footer={
        <Button type="button" variant="primary" className="w-full sm:w-auto" onClick={onClose}>
          知道了
        </Button>
      }
    >
      <p className="text-sm leading-relaxed text-slate-600">
        「{feature}」包含多列表格、长表单或复杂配置，在手机上不便操作与核对。
      </p>
      <p className="mt-3 text-sm leading-relaxed text-slate-600">
        请使用<strong className="font-semibold text-slate-800">电脑浏览器</strong>
        打开本系统同一网址登录，即可使用完整后台。
      </p>
    </Modal>
  );
}
